import usePageName from "../../../hocs/usePageName";
import { useNavigate, useParams } from "react-router-dom";
import { useContext, useState } from "react";
import { AuthContext } from "../../../context/AuthContext";
import SearchBar from "../../../components/SearchBar";
import InfiniteScroller from "../../../components/InfiniteScroller/InfiniteScroller";
import FabButton from "../../../components/CustomerComponents/FabButton";
import { Add, Check } from "@mui/icons-material";
import ListFooter from "../../../components/InfiniteScroller/ListFooter";
import OrderCard from "../../../components/OrderCard";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  ListItem,
  ListItemText,
  Modal,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@emotion/react";
import ProjectCard from "../Projects/ProjectCard";
import useProjects from "../../../hooks/useProjects";
import { SnackAlertContext } from "../../../context/SnackAlertContext";
import useCompanyOrders from "../../../hooks/useCompanyOrders";
import { LoadingButton } from "@mui/lab";
import { initialOrder } from "../../../context/MobileOrderContext";

const Quotes = () => {
  usePageName({ heading: "Quotes" });
  const navigate = useNavigate();
  const { openSnackMessage } = useContext(SnackAlertContext);
  const { authToken, ezorder, decoded } = useContext(AuthContext);
  const theme = useTheme();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  // const [
  //   searchQuery,
  //   setSearchQuery,
  //   results,
  //   onRefresh,
  //   refreshing,
  //   onLoadMore,
  //   loadingMore,
  //   total,
  //   hasMore,
  // ] = useCompanyQuotes(authToken, 10);
  const [
    searchQuery,
    setSearchQuery,
    results,
    onRefresh,
    refreshing,
    onLoadMore,
    loadingMore,
    total,
    hasMore,
  ] = useCompanyOrders(authToken, 50, "quote-requests");

  const [
    project_searchQuery,
    project_setSearchQuery,
    project_results,
    project_onRefresh,
    project_refreshing,
    project_onLoadMore,
    project_loadingMore,
    project_total,
    project_hasMore,
  ] = useProjects(authToken, 20, true);
  const [projectName, setProjectName] = useState("");

  const [createModalOpen, setCreateModalOpen] = useState(false);
  const handleClose = () => {
    setCreateModalOpen(false);
    setProjectName("");
  };

  const handleSubmitProject = async ({ name }) => {
    try {
      if (!name) return;
      setIsSubmitting(true);
      const result = await ezorder.post(
        "/projects",
        { name },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (decoded.isVendorOrSupplier) {
        openSnackMessage("success", "Customer Created");
      } else {
        openSnackMessage("success", "Project Created");
      }
      let newProject = result.data.project;
      createNewOrderForProject(newProject.id);
    } catch (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        openSnackMessage("error", error.response.data.error);
      } else {
        // Something went really bad
        console.log(error);
        openSnackMessage("error", error);
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const createNewOrderForProject = async (projectId) => {
    try {
      setIsSubmitting(true);
      const requestBody = {
        projectId: parseInt(projectId),
        orderDetails: { ...initialOrder },
      };

      const response = await ezorder.post(`/orders`, requestBody, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      console.log(response);
      if (response.status == 200 || response.status === 201) {
        navigate(`/quotes/${response.data.order.id}`, {
          replace: true,
        });
      }
    } catch (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        openSnackMessage("error", error.response.data.error);
      } else {
        // Something went really bad
        console.log(error);
        openSnackMessage("error", error);
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const copyOrder = async (orderId) => {
    try {
      setIsSubmitting(true);
      const response = await ezorder.post(
        `/orders/${orderId}/copy`,
        {},
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      openSnackMessage("success", "Order Copied");
      let copied = response.data.order;
      // navigate(`/projects/${copied.project.id}/orders/${copied.id}`);
      navigate(`/quotes/${copied.id}`);
    } catch (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        openSnackMessage("error", error.response.data.error);
      } else {
        // Something went really bad
        console.log(error);
        openSnackMessage("error", error);
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const deleteSavedQuoteRequest = async (orderId) => {
    try {
      setIsSubmitting(true);
      const response = await ezorder.delete(`/orders/${orderId}`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      openSnackMessage("success", "Quote Request Deleted");
      onRefresh();
    } catch (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        openSnackMessage("error", error.response.data.error);
      } else {
        // Something went really bad
        console.log(error);
        openSnackMessage("error", error);
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <SearchBar
        label="Search Quotes"
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
      />
      <InfiniteScroller
        items={results}
        renderItem={(item, index) => {
          return (
            <OrderCard
              key={item.id}
              order={item}
              clickHandler={() => {
                // navigate(`/projects/${item.project.id}/orders/${item.id}`)
                navigate(`/quotes/${item.id}`);
              }}
              onCopy={() => {
                copyOrder(item.id);
              }}
              isCopying={isSubmitting}
              onDelete={() => {
                deleteSavedQuoteRequest(item.id);
              }}
            />
          );
        }}
        onRefresh={onRefresh}
        onEndReached={onLoadMore}
        loading={refreshing || loadingMore || isSubmitting}
        ListFooterComponent={() => {
          return <ListFooter hasMore={hasMore} onClick={onLoadMore} />;
        }}
      />
      <FabButton
        color="success"
        onClick={() => {
          //navigate("/projects");
          setCreateModalOpen(true);
        }}
      >
        <Add sx={{ mr: 1 }} />
        Request a Quote
      </FabButton>
      <Dialog
        keepMounted
        scroll={"paper"}
        maxWidth="sm"
        fullWidth={true}
        fullScreen={fullScreen}
        open={createModalOpen}
        onClose={handleClose}
      >
        <DialogTitle>Create NEW Quote Request</DialogTitle>
        <DialogContent
          sx={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <DialogContentText>
            Create a Quote Request For A New{" "}
            {decoded.isVendorOrSupplier ? "Customer" : "Project"}
          </DialogContentText>
          <Box
            sx={{
              marginTop: "8px",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <TextField
              size="small"
              sx={{ flex: 1 }}
              label={`Enter New ${
                decoded.isVendorOrSupplier ? "Customer" : "Project"
              } Name`}
              value={projectName}
              onChange={(e) => {
                setProjectName(e.target.value);
              }}
            />
            <LoadingButton
              loading={isSubmitting}
              sx={{ marginLeft: "8px" }}
              variant="contained"
              color="success"
              onClick={() =>
                handleSubmitProject({
                  name: projectName,
                })
              }
            >
              <Check />
            </LoadingButton>
            {/* <IconButton variant="contained" aria-label="Example">
              <ChevronRight />
            </IconButton> */}
          </Box>
          <DialogContentText sx={{ marginTop: "32px" }}>
            Or Create a Quote Request For an Existing{" "}
            {decoded.isVendorOrSupplier ? "Customer" : "Project"}
          </DialogContentText>
          <SearchBar
            label={
              decoded.isVendorOrSupplier
                ? "Search Customers"
                : "Search Projects"
            }
            searchQuery={project_searchQuery}
            setSearchQuery={project_setSearchQuery}
          />
          <Box
            sx={{
              flex: 1,
              minHeight: project_results.length > 0 ? "200px" : "0px",
              overflowY: "scroll",
            }}
          >
            <InfiniteScroller
              items={project_results}
              renderItem={(item, index) => {
                return (
                  <>
                    <ListItem
                      key={item.id}
                      project={item}
                      onClick={() => {
                        if (!isSubmitting) createNewOrderForProject(item.id);
                      }}
                    >
                      <ListItemText primary={item.name} />
                    </ListItem>
                    <Divider />
                  </>
                );
              }}
              onRefresh={project_onRefresh}
              onEndReached={project_onLoadMore}
              loading={project_refreshing || project_loadingMore}
              ListFooterComponent={() => {
                return (
                  <ListFooter
                    hasMore={project_hasMore}
                    onClick={project_onLoadMore}
                  />
                );
              }}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} autoFocus>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Quotes;
